const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  device: state => state.app.device,
  projectInfo:state => state.app.projectInfo,
  pageConfig:state => state.app.pageConfig,
  warningNum:state =>state.app.warningNum,
  projectList:state => state.app.projectList,
  lastAlertPoint:state => state.app.lastAlertPoint,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  userInfo: state => state.user.userInfo,
  firstRouters: state => state.permission.routers,
  secondRouters: state => state.permission.secondRouters,
  addRouters: state => state.permission.addRouters,
  routerKeyData:state => state.permission.routerKeyData,
  buttonPageObj:state => state.permission.buttonPageObj,
  floatzIndex:state => state.float.floatzIndex,
  floatList:state => state.float.floatList,
  theme:state => state.app.theme,
  factorInfo:state => state.app.factorInfo,
  weather:state => state.app.weather,
  domainList:state => state.app.domainList,
  currentDomain: state => state.app.currentDomain
}
export default getters
